interface InspectionProjectSource {
	ballooning_project_id?: string | null;
	lot_inspection_project_id?: string | null;
}

/** The BallooningProject id a line item should use for inspection/ballooning.
 *  For a Swiss-lot sibling the backend supplies lot_inspection_project_id (the lot
 *  parent's project); otherwise fall back to the item's own ballooning_project_id. */
export function getInspectionProjectId(
	lineItem: InspectionProjectSource | undefined | null,
): string | undefined {
	if (!lineItem) return undefined;
	return lineItem.lot_inspection_project_id ?? lineItem.ballooning_project_id ?? undefined;
}

interface LotInspectionGateSource extends InspectionProjectSource {
	ballooning_status?: string | null;
}

/** Whether to render the inline inspection widgets (sample matrix / keyence programs)
 *  on the order line-item detail page. True when this item's own ballooning is complete
 *  (parent / non-Swiss — unchanged behavior), OR it's a Swiss-lot sibling reading through
 *  to the lot parent's project (no own project, but a lot project exists). */
export function shouldShowLotInspection(lineItem: LotInspectionGateSource | undefined | null): boolean {
	if (!lineItem) return false;
	if (lineItem.ballooning_status === 'Completed') return true;
	return !lineItem.ballooning_project_id && !!lineItem.lot_inspection_project_id;
}

/** Filter a shared lot plan's samples down to one batch. For a Swiss lot, each
 *  sample is tagged with its batch (order_line_item); a sibling's matrix should
 *  show only its own. With no batch id, or when no sample is tagged (legacy
 *  plans created before per-batch tagging), return everything unchanged. */
export function filterSamplesForBatch<T extends { order_line_item?: string | null }>(
	samples: T[],
	orderLineItemId?: string | null,
): T[] {
	if (!orderLineItemId) return samples;
	const anyTagged = samples.some((s) => s.order_line_item != null);
	if (!anyTagged) return samples;
	return samples.filter((s) => s.order_line_item === orderLineItemId);
}
